

























import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

@Component
export default class Search extends Vue {
  show = false;

  queries = [
    'first_name = "noah"',
    'username ~ "purple"',
    'username ~ "purple" AND first_name = "noah"'
  ];
  constructor() {
    super();
  }
  setTo(query: string) {
    this.$emit("helpClicked", query);
  }
}
